<template>
  <div id="appId">
    <div class="tab-bar" >
      <div class="home"  @mouseenter="enters(0)"
           @mouseleave="leaver(0)" >
        <router-link style="color: white" to="/home">首页</router-link>
        <div v-show="switchNice[0].arrys" class="divLine" ></div>
      </div>
      <div class="about" @mouseenter="enters(1)"
           @mouseleave="leaver(1)" >
        <router-link style="color: white" to="/about">公司简介</router-link>
        <div v-show="switchNice[1].arrys" class="divLineAbout" ></div>
      </div>
      <div class="cooperation" @mouseenter="enters(2)"
           @mouseleave="leaver(2)">
        <router-link style="color: white" to="/cooperation">合作方式</router-link>
        <div v-show="switchNice[2].arrys" class="divLineAbout" ></div>
      </div>
      <div class="software" @mouseenter="enters(3)"
           @mouseleave="leaver(3)">
        <router-link style="color: white" to="/software">应用软件</router-link>
        <div v-show="switchNice[3].arrys" class="divLineAbout" ></div>
      </div>

<!--      <div oncontextmenu = "return false" oncopy = "return false" onselectstart = "return false" class="Tianmao" @mouseenter="enters(4)"-->
<!--           @mouseleave="leaver(4)">-->
<!--        <a style="color: white;width: 65px;height: 4px;" href="https://chuangyixingznsb.tmall.com/?spm=a220o.1000855.w5001-23145040949.2.5be57c9fOu1m3w&scene=taobao_shop">天猫商城</a>-->
<!--        <div v-show="switchNice[4].arrys" class="divLineAbout" ></div>-->
<!--      </div>-->

      <!--<div class="tab-bar-item" @click="home"></div>-->
      <!--<div class="tab-bar-item" @click="companyClick">公司简介</div>-->
      <!--<div class="tab-bar-item" @click="cooperationClick">合作方式</div>-->
      <!--<div class="tab-bar-item" @click="softwareClick">应用软件</div>-->
      <!--<div class="tab-bar-item" @click="shopping">天猫商城</div>-->
    </div>
    <router-view/>

  </div>

</template>

<script>
export default {
  name: 'App',
  data(){
    return{

      switchNice: [
        //这绑定了上面V-show,
        {
          arrys: false
        },
        {
          arrys: false
        },
        {
          arrys: false
        }
        ,
        {
          arrys: false
        }
        ,
        {
          arrys: false
        }
      ]

    }

  },
  comments:{
    path:'/home'
  },
  methods:{
    enters(index) {
      console.log("进入")
      this.switchNice[index].arrys = true; //这里的先后顺序如果写反了 就会一直闪，这是根据上面那个思路写的，
    },
    leaver(index) {
      console.log("离开")
      this.switchNice[index].arrys = false; //移出时也一样，先B消失 再出现A。
    }
  }
}
</script>

<style>
@import "./assets/css/base.css";
  .tab-bar{
    position: absolute;
    z-index: 1000;
    right: 20px;
    top:10px;
  }
.divLine{
  width: 2rem;
  height: 4px;
  background-color: gold;
  border-radius:4px;
  top:100px;
}
.divLineAbout{
  width: 4rem;
  height: 4px;
  background-color: gold;
  border-radius:4px;
  top:100px;
}
  #appId{
    z-index: 1000;
  }
  .home{
    float: left;
    display: inline;
    z-index: 1000;
    min-width: 3rem;
  }
.about{
  float: left;
  display: inline;
  z-index: 1000;
  min-width: 85px;
}


.cooperation{
  float: left;
   display: inline;
  z-index: 1000;
  min-width: 5rem;
 }

.software{
  float: left;
  display: inline;
  z-index: 1000;
  min-width: 5rem;
}
.Tianmao{
  float: left;
  display: inline;
  z-index: 1000;
  min-width: 5rem;
}
a {
  text-decoration: none;
}
.part5{
  background-color: black;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue